class CartDrawer extends HTMLElement {
	constructor() {
		super()
		window.FoxTheme = window.FoxTheme || {}
		window.FoxTheme.Cart = this
		this.drawer = this.closest('drawer-component')
		window.FoxTheme.CartDrawer = this.drawer
    this.openWhenAdded = this.dataset.openWhenAdded === 'true'
	}

	connectedCallback() {
    window.FoxThemeEvents.subscribe(`ON_ITEM_ADDED`, async state => {
      this.renderContents(state)
    })
	}

  renderContents(parsedState, renderFooter = true) {
    this.classList.contains('is-empty') && this.classList.remove('is-empty');
    this.getSectionsToRender(renderFooter).forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      if (this.openWhenAdded && !this.drawer.isOpen()) {
        this.drawer.openDrawer()
        document.body.classList.add('prevent-scroll')
        window.FoxThemeEvents.emit(`ON_CART_DRAWER_OPEN`, parsedState)
      }
    });

  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender(renderFooter = false) {
    const sections = [
      {
        id: 'cart-drawer',
        selector: '.f-cart-drawer__items',
      },
    ]

    if (renderFooter) {
      sections.push({
        id: 'cart-drawer',
        selector: '.f-drawer__footer',
      })
    }

    return sections
  }

}
customElements.define('cart-drawer', CartDrawer)

class CartDrawerItems extends CartItems {
  initLoading() {
    this.loading = new window.FoxTheme.AnimateLoading(document.querySelector('cart-drawer'), { overlay: document.querySelector('cart-drawer') })
    this.combineWishlistProducts();
  }

  getSectionsToRender() {
    return [
      {
        id: 'Drawer-Cart',
        section: 'cart-drawer',
        selector: '.f-cart-drawer__items',
      },
      {
        id: 'Drawer-Cart',
        section: 'cart-drawer',
        selector: '.f-cart-drawer__block-subtotal',
      }
    ];
  }

  combineWishlistProducts() {
    const cartItemsWithOffer = document.querySelector('.f-cart-drawer__items--offer');
    if (!cartItemsWithOffer) return;

    async function combineProductsFromWishlist() {
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart.js', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        });
        const cart = await response.json();
        const section = {
          id: 'Drawer-Cart',
          section: 'cart-drawer',
          selector: '.f-cart-drawer__items',
        };
        const reverseItems = [...cart.items].reverse();
        let counter = reverseItems.length;

        for (const item of reverseItems) {
          if (item.properties.offer) {
            gtag('event', 'added_product_from_wishlist', {
              'item_id': item.id,
              'item_key': item.key,
              'item_name': item.title,
              'item_brand': item.vendor,
              'item_category': item.product_type,
              'price': item.price / 100,
              'quantity': item.quantity
            });
          }

          const updatedProperties = { ...item.properties };
          delete updatedProperties.offer;

          const body = JSON.stringify({
            line: counter,
            quantity: item.quantity,
            properties: updatedProperties,
            sections: [section.section],
            sections_url: window.location.pathname,
          });

          const updateResponse = await fetch(`${FoxThemeSettings.routes.cart_change_url}`, { ...fetchConfig, ...{ body } });

          counter--;
          const updateData = await updateResponse.text();
          const parsedState = await JSON.parse(updateData);
          const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          if (elementToReplace) {
            const domParser = new DOMParser().parseFromString(parsedState.sections[section.section], 'text/html');
            const newSection = domParser.querySelector(section.selector) ? domParser.querySelector(section.selector).innerHTML : '';
            elementToReplace.innerHTML = newSection;
          }
        }
      } catch (error) {
        console.error('Error:', error);
      }
    }

    combineProductsFromWishlist();
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
